import React from "react";

export default function Loading(props) {
  return (
    <>
      {props.isLoading ? (
        <div className="flex items-center justify-center min-h-[200px]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#DD8732]"></div>
        </div>
      ) : (
        <>{props.children}</>
      )}
    </>
  );
}
